/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbTypeCoursDto
 */
export interface FcbTypeCoursDto {
    /**
     * 
     * @type {string}
     * @memberof FcbTypeCoursDto
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbTypeCoursDto
     */
    libelle?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FcbTypeCoursDto
     */
    creationUser?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FcbTypeCoursDto
     */
    actif?: boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbTypeCoursDto
     */
    modificationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbTypeCoursDto
     */
    modificationUser?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof FcbTypeCoursDto
     */
    creationDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof FcbTypeCoursDto
     */
    typeCoursId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FcbTypeCoursDto
     */
    acquisIfapme?: boolean;
}

/**
 * Check if a given object implements the FcbTypeCoursDto interface.
 */
export function instanceOfFcbTypeCoursDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbTypeCoursDtoFromJSON(json: any): FcbTypeCoursDto {
    return FcbTypeCoursDtoFromJSONTyped(json, false);
}

export function FcbTypeCoursDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbTypeCoursDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'libelle': !exists(json, 'libelle') ? undefined : json['libelle'],
        'creationUser': !exists(json, 'creationUser') ? undefined : json['creationUser'],
        'actif': !exists(json, 'actif') ? undefined : json['actif'],
        'modificationDate': !exists(json, 'modificationDate') ? undefined : (json['modificationDate'] === null ? null : new Date(json['modificationDate'])),
        'modificationUser': !exists(json, 'modificationUser') ? undefined : json['modificationUser'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (json['creationDate'] === null ? null : new Date(json['creationDate'])),
        'typeCoursId': !exists(json, 'typeCoursId') ? undefined : json['typeCoursId'],
        'acquisIfapme': !exists(json, 'acquisIfapme') ? undefined : json['acquisIfapme'],
    };
}

export function FcbTypeCoursDtoToJSON(value?: FcbTypeCoursDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'libelle': value.libelle,
        'creationUser': value.creationUser,
        'actif': value.actif,
        'modificationDate': value.modificationDate === undefined ? undefined : (value.modificationDate === null ? null : value.modificationDate.toISOString()),
        'modificationUser': value.modificationUser,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate === null ? null : value.creationDate.toISOString()),
        'typeCoursId': value.typeCoursId,
        'acquisIfapme': value.acquisIfapme,
    };
}

